module.exports = __webpack_public_path__ + "img/npc_contact_jesper.892e01dd.jpg";